import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTENT } from "@/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Sheet-URLs ohne Protokoll (z. B. "eventim.de/xyz") sonst als relative
// tonesound.de-Links geöffnet würden — hier normalisieren.
const ticketHref = (u) => {
  if (!u || u === "#") return null;
  return /^(https?:|mailto:)/i.test(u) ? u : `https://${u}`;
};

export default function Shows() {
  // Sobald das Google Sheet verbunden ist, kommen die Shows von dort.
  // Sonst Fallback auf die Einträge in content.js.
  const [sheetShows, setSheetShows] = useState(null);

  useEffect(() => {
    fetch(`${API}/shows`)
      .then((r) => r.json())
      .then((d) => {
        if (d.configured) setSheetShows(d.shows || []);
      })
      .catch(() => {});
  }, []);

  const shows = sheetShows === null ? CONTENT.shows : sheetShows;
  return (
    <section id="shows" data-testid="shows-section" className="relative py-28 md:py-44 px-6 md:px-16 max-w-[1600px] mx-auto border-t border-white/5">
      <Reveal className="flex items-end justify-between mb-12 md:mb-20">
        <h2 className="font-display font-extrabold uppercase tracking-tight leading-none text-4xl sm:text-6xl lg:text-7xl text-[#f5f3ef]">
          LIVE / SHOWS
        </h2>
      </Reveal>

      {shows.length === 0 ? (
        <Reveal>
          <p data-testid="shows-empty" className="font-display font-bold uppercase tracking-tight text-2xl md:text-4xl text-[#64646e]">
            MORE SHOWS COMING SOON
          </p>
          <p className="font-mono2 text-[11px] tracking-[0.3em] text-[#38bdf8] mt-4 uppercase">
            STAY CONNECTED — {CONTENT.instagram.handle}
          </p>
        </Reveal>
      ) : (
        <div data-testid="shows-list">
          {shows.map((s, i) => (
            <Reveal key={`${s.date}-${s.event}`} delay={0.06 * i}>
              <div
                data-testid={`show-row-${i}`}
                className="group grid grid-cols-12 items-center gap-3 md:gap-6 border-t border-white/10 py-7 md:py-10 px-2 md:px-4 hover:bg-white/[0.03] transition-colors duration-500"
              >
                <p className="col-span-12 md:col-span-3 min-w-0 font-mono2 text-xs md:text-sm tracking-[0.25em] text-[#a3a3ac]">
                  {s.date}
                </p>
                <h3 className="col-span-12 md:col-span-5 min-w-0 break-words font-display font-bold uppercase tracking-tight text-lg sm:text-2xl md:text-4xl text-[#f5f3ef] group-hover:text-[#70c7fa] transition-colors duration-500 leading-none">
                  {s.event}
                </h3>
                <p className="col-span-6 md:col-span-2 min-w-0 break-words font-mono2 text-[10px] md:text-xs tracking-[0.25em] text-[#64646e] uppercase leading-relaxed">
                  {s.city}
                </p>
                <div className="col-span-6 md:col-span-2 flex md:justify-end shrink-0">
                  {ticketHref(s.tickets) && (
                    <a
                      data-testid={`show-ticket-btn-${i}`}
                      href={ticketHref(s.tickets)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-5 py-2.5 border border-white/15 font-mono2 text-[10px] tracking-[0.3em] text-[#f5f3ef] hover:border-[#38bdf8]/70 hover:text-[#70c7fa] hover:shadow-[0_0_24px_rgba(56,189,248,0.15)] transition-all duration-500"
                    >
                      TICKETS <ArrowUpRight className="w-3.5 h-3.5" />
                    </a>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-white/10" />
        </div>
      )}
    </section>
  );
}
